<app-input-form-modal
  *ngIf="fields?.length"
  [inputFields]="fields"
  [modalConfig]="modalConfig"
  (cancel)="onCancel()"
  (save)="onSave($event)"
>
</app-input-form-modal>
